import { Customer } from 'server/shared/models/customer';
import { RoleEnum } from 'server/shared/models/role.enum';
import { getUsersMongoSearchQuery } from 'server/shared/helpers/getUsersMongoSearchQuery';
import { User } from 'server/shared/models/user';

export function getEmploymentAvailabilityUsersQuery(
  search: string | undefined,
  department: string | undefined,
  certificates: string | undefined,
  currentCustomer: Customer,
  sharedPoolCustomers: Customer[],
): Mongo.Selector<User> {
  const andQuery: Mongo.Selector<User>[] = [
    {
      role: RoleEnum.POOL,
      $or: [currentCustomer, ...sharedPoolCustomers].map((customer) => ({
        _id: {
          $in: customer.pool.activeUserIds,
        },
        [`customerInformation.${customer._id}.enableEmployments`]: true,
      })),
    },
  ];
  if (search) {
    andQuery.push({
      $or: getUsersMongoSearchQuery(search, currentCustomer._id),
    });
  }
  if (department) {
    let departmentQuery: any = {
      [`customerInformation.${currentCustomer._id}.departmentIds`]: department,
    };
    if (sharedPoolCustomers && sharedPoolCustomers.length) {
      departmentQuery = {
        $or: [
          {
            [`customerInformation.${currentCustomer._id}.departmentIds`]:
              department,
          },
        ],
      };
      sharedPoolCustomers.forEach((customer) => {
        departmentQuery['$or'].push({
          [`customerInformation.${customer._id}.departmentIds`]: department,
        });
      });
    }
    andQuery.push(departmentQuery);
  }
  if (certificates) {
    const certificatesArray = certificates.split(',');
    andQuery.push({
      'certificates.id': {
        $in: certificatesArray,
      },
    });
  }
  return {
    $and: andQuery,
  };
}
